import { jsx } from "react/jsx-runtime";
import MGrid from "@mui/material/Grid";
import styled from "@mui/material/styles/styled";
import { filterValidProps } from "../../shared/helpers";
import { useTheme } from "../ThemeProvider";
const CustomGrid = styled(MGrid)(({ theme, sx }) => {
  return {
    ...sx
  };
});
const Grid = ({ sx, ...props }) => {
  const theme = useTheme();
  const newSx = filterValidProps(sx || {});
  return /* @__PURE__ */ jsx(CustomGrid, { theme, sx: newSx, ...props });
};
var Grid_default = Grid;
export {
  Grid_default as default
};
